module.exports = __webpack_public_path__ + "static/pic08.6ef3e5cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic08.jpg
// module id = 491
// module chunks = 114276838955818